import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_SCREEN_OK = "GET_LOOKUP_SCREEN_OK";
export const GET_LOOKUP_SCREEN_ERR = "GET_LOOKUP_SCREEN_ERR";

export const lookupScreenAction = {
  getLookupScreen,
};

function getLookupScreenOk(payload) {
  return { type: GET_LOOKUP_SCREEN_OK, payload };
}
function getLookupScreenErr(payload) {
  return { type: GET_LOOKUP_SCREEN_ERR, payload };
}

function getLookupScreen() {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetScreenLookup)
      .then((response) => {
        dispatch(getLookupScreenOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getLookupScreenErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
